var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.234 4.383 2.953.283c1.028.099 1.343 1.103.55 1.762l-2.313 1.921.859 3.13c.282 1.029-.593 1.65-1.469 1.032l-2.809-1.984-2.809 1.984c-.872.616-1.75-.003-1.468-1.031l.858-3.13-2.312-1.922c-.797-.662-.483-1.663.549-1.762l2.953-.283 1.3-3c.408-.938 1.451-.938 1.858.001l1.3 2.999Z",
    fill: "currentColor"
  })));
};
export default SvgStar;